var Popups = [];
var PopupLoaded = false;
var POPUP_DEBUG = false;

(function (arr) {
	arr.forEach(function (item) {
	  if (item.hasOwnProperty('remove')) {
		return;
	  }
	  Object.defineProperty(item, 'remove', {
		configurable: true,
		enumerable: true,
		writable: true,
		value: function remove() {
		  if (this.parentNode === null) {
			return;
		  }
		  this.parentNode.removeChild(this);
		}
	  });
	});
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

function Popup(params) {
	this.button = params.buttons;
	this.content = params.content;
	this.element = params.element;
}

Popup.prototype.setup = function() {
	var popups = document.getElementsByClassName('m-Popup');

	if (popups.length > 0) {
		for (var i = popups.length - 1; i >= 0; i--) {
			var p = popups[i];
			var close = p.getElementsByClassName('js-popupClose');
			var content = p.getElementsByClassName('js-content')[0];
			var params = {
				buttons: close,
				content: content,
				element: p,
			}

			var obj = new Popup(params);
			Popups.push(obj);
			obj.init()
		}
	}
}

Popup.prototype.init = function() {
	// first, check is the Alert has is in the localStorage
	var inLocaleStorage = this.getLocaleStorage();
	var timeToWait = 86400000;

	var closedTime = new Date(this.getLocaleStorageDate());
	var currentTime = new Date();
	var oneDayPassed = false;
	var showPopup = false;

	if (closedTime != null) {
		oneDayPassed = timeToWait < currentTime.getTime() - closedTime.getTime()
	}
	
	if (POPUP_DEBUG) {
		console.log('inLocaleStorage : ', inLocaleStorage);
		console.log('closedTime : ', closedTime);
		console.log('currentTime: ', currentTime);
		console.log('oneDayPassed: ', oneDayPassed);
		console.log('currentTime.getTime(): ', currentTime.getTime());
		console.log('closedTime.getTime(): ', closedTime.getTime());
		console.log('showTime: ', new Date(closedTime.getTime() + timeToWait) ); 
	}

	// test to see if we need to show the popup
	if (oneDayPassed) {
		showPopup = true;
	}

	if (!inLocaleStorage && !oneDayPassed) {
		showPopup = true;
	}

	// if the Alert has not been showed..
	if (showPopup) {
		this.showAlert();
	}

	if (inLocaleStorage) {
		this.element.classList.add('js-alertShowed')
	}
}

Popup.prototype.getLocaleStorage = function() {
	var id = this.content.innerHTML;
	return JSON.parse(window.localStorage.getItem(id));
}

Popup.prototype.getLocaleStorageDate = function() {
	return window.localStorage.getItem('hippodrome_close_time');
}

Popup.prototype.showAlert = function() {
	AlertLoaded = true,
	this.element.classList.remove('is-hidden');
	window.localStorage.removeItem('hippodrome_close_time');
	this.addCloseListener();
	this.movePopup();
}

Popup.prototype.addCloseListener = function() {
	var close = this.button;

	for (var i = close.length - 1; i >= 0; i--) {
		var c = close[i]
		c.addEventListener('click', this.hideAlert.bind(this));
	}
}

Popup.prototype.hideAlert = function() {
	this.element.classList.add('is-hidden');
	this.setLocaleStorage();
	this.setLocaleStorageDate();
}

Popup.prototype.setLocaleStorage = function() {
	var id = this.content.innerHTML;

	this.element.classList.add('js-alertShowed')
	window.localStorage.setItem(id, AlertLoaded);
}

Popup.prototype.removeLocaleStorage = function() {
	var id = this.content.innerHTML;

	this.element.classList.add('js-alertShowed')
	window.localStorage.removeItem(id);
}

Popup.prototype.setLocaleStorageDate = function() {
	window.localStorage.setItem('hippodrome_close_time', new Date());
}

Popup.prototype.movePopup = function() {
	var target = document.getElementById('js-PopupLocation');
	var elementBackup = this.element;

	this.element.remove();

	target.appendChild(elementBackup);
	this.element = elementBackup;
}